import { useCallback, useMemo } from 'react';

import AutocompleteWithChips from 'components/Basic/AutocompleteWithChips/AutocompleteWithChips';
import { SelectedItemDto } from 'types/CodegenReportTypes';
import { useGetLookupGameTypes } from 'hooks/CodegenLookupHooks';
import { useTranslation } from 'react-i18next';

type Props = {
  selectedGameTypeId: string | undefined;
  onChange: (level: SelectedItemDto) => void;
};

const SelectGameType = ({ selectedGameTypeId, onChange }: Props) => {
  const { t } = useTranslation();
  const { data, isLoading } = useGetLookupGameTypes();

  const allOptionIds = useMemo(() => data?.map((datum) => datum.id) ?? [], [data]);
  const getOptionName = useCallback(
    (id: string) => {
      const name = data?.find((datum) => datum.id === id)?.name;
      return name != null ? t(name) : (t('Nonexistent game type') as string);
    },
    [data]
  );

  return (
    <AutocompleteWithChips
      label={t('GameType')}
      options={allOptionIds}
      selected={selectedGameTypeId ?? ''}
      setSelected={(id) => onChange({ id: id, name: getOptionName(id) })}
      getOptionLabel={(option) => (isLoading ? t('Loading game types...') : getOptionName(option))}
      noOptionsText={isLoading ? t('Loading game types...') : t('No game types found')}
      single
    />
  );
};

export default SelectGameType;
